module.exports = __webpack_public_path__ + "static/media/scott.61ce630d.png";